// extracted by mini-css-extract-plugin
export default {"root":"ProductHistoryEventCard_root__SV7by","buttonContainer":"ProductHistoryEventCard_buttonContainer__ew1Ig","expandButton":"ProductHistoryEventCard_expandButton__o12y8"};